"use client";
import {FileChip} from "@/components/pages/vehicles/FileChip";
import {NeoLabel} from "@/components/shared";
import {vehicleService} from "@/service/vehicle.service";
import {Card, CardBody} from "@nextui-org/react";
import {Label} from "flowbite-react";
import {useEffect, useState} from "react";
import toast from "react-hot-toast";
import {FiUserX} from "react-icons/fi";

interface DriverDetailsProps {
  driveId: string;
  onRemove: (data: any) => void;
}

export const DriverDetails: React.FC<DriverDetailsProps> = ({
  driveId,
  onRemove
}) => {
  const [driver, setDriver] = useState<any>(null);
  const [driverdata, setDriverData] = useState<any>([]);
  useEffect(() => {
    if (driveId) {
      fetchDriver();
    }
  }, [driveId]);

  const fetchDriver = async () => {
    try {
      const response = await vehicleService.onDriverDetails(driveId);
      if (response?.data?.status === "success") {
        setDriverData(response.data.data);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (err: any) {
      if (err?.errors?.length > 0) {
        err.errors.forEach(
          ({field, message}: {field: any; message: string}) => {
            toast.error(message);
          }
        );
      }
    }
  };

  const removedriver = () => {
    const requestdata: any = {
      driverId: driveId,
      assign: false
    };
    onRemove(requestdata);
  };
  return (
    <>
      <Card>
        <CardBody>
          <div className="w-full p-6">
            <div className="grid w-full grid-cols-1 items-center gap-6 lg:grid-cols-[auto,1fr]">
              {/* Image */}
              <div className="flex items-start justify-center">
                <img
                  src={driverdata?.driverPhoto || "/icons/user.svg"}
                  alt="Profile"
                  className="h-24 w-24 rounded-full object-cover"
                />
              </div>

              <div className="grid w-full grid-cols-1 gap-4">
                <div className="flex items-center justify-between">
                  <p className="font-bold">{driverdata?.name}</p>
                  <button
                    title="Unassign Driver"
                    onClick={() => removedriver()}
                  >
                    <FiUserX className="text-xl font-bold text-red-500" />
                  </button>
                </div>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                  <div>
                    <NeoLabel
                      label="Phone No"
                      value={driverdata?.phoneNumber || "N/A"}
                    />
                  </div>
                  <div>
                    <NeoLabel
                      label="Email"
                      value={driverdata?.email || "N/A"}
                    />
                  </div>
                  <div>
                    <NeoLabel label="DOB" value={driverdata?.dob || "N/A"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <div className="mt-1 grid grid-cols-1 gap-2 md:grid-cols-2">
        <Card className="mb-2">
          <CardBody>
            <Label
              className="-mt-2 block p-2 text-xl font-bold"
              value="License Details"
            />
            <div className="flex-row px-3">
              <div className="flex flex-wrap">
                <div className="mb-5 w-1/2">
                  <NeoLabel
                    label="License No"
                    value={driverdata.licenseNumber || "N/A"}
                  />
                </div>
                <div className="mb-5 w-1/2">
                  <NeoLabel
                    label="License Validity Date"
                    value={driverdata.licenseValidityDate || "N/A"}
                  />
                </div>
              </div>
              {driverdata.licenseDocuments?.length > 0 && (
                <div className="flex flex-col gap-2">
                  <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                    {driverdata.licenseDocuments.map(
                      (fileItem: any, index: number) => (
                        <FileChip
                          key={fileItem.id}
                          file={fileItem}
                          classNames="w-full"
                        />
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          </CardBody>
        </Card>
        <Card className="mb-2">
          <CardBody>
            <Label
              className="-mt-2 block p-2 text-xl font-bold"
              value="Documents"
            />
            <div className="flex-row px-3">
              {driverdata.otherDocuments?.length > 0 ? (
                <div className="mt-4 flex flex-col gap-2">
                  <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                    {driverdata.otherDocuments.map((fileItem: any) => (
                      <FileChip
                        key={fileItem.id}
                        file={fileItem}
                        classNames="w-full"
                      />
                    ))}
                  </div>
                </div>
              ) : (
                <div className="mt-3 flex flex-col items-center justify-center">
                  <img
                    src="/images/nodata.svg"
                    alt="No Documents"
                    className="max-w-[120px] opacity-70"
                  />
                  <Label
                    className="text-md mt-2 block p-2 font-bold"
                    value="No documents uploaded"
                  />
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
};
